import React, { useEffect, useState } from 'react'
import { Routes, Route, NavLink, useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Col, Container, Nav, Navbar, Row, Button } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import { getCurrentUser, signOut } from 'aws-amplify/auth'
import { Hub } from 'aws-amplify/utils'
import { fetchCharities } from '../../reducers/charitiesSlice'
import Home from '../home'
import CharityList from '../charities'
import AdminLogin from '../admin/login'
import AdminCharities from '../admin/charities'
import AdminSnp500 from '../admin/snp500'
import AdminSre from '../admin/sre'
import AdminStock from '../admin/stock'
import AdminInvestments from '../admin/investments'
import PrivateRoute from '../../components/PrivateRoute'
import FullArticle from '../../components/fullarticle'
import News from '../news'
import NotFound from '../notFound'
import logo from '../../resources/Maple.jpg'

const App = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [authState, setAuthState] = useState('loading') // 'loading' | 'authenticated' | 'unauthenticated'

  useEffect(() => {
    dispatch(fetchCharities())
  }, [dispatch])

  useEffect(() => {
    getCurrentUser()
      .then(() => setAuthState('authenticated'))
      .catch(() => setAuthState('unauthenticated'))

    const unsubscribe = Hub.listen('auth', ({ payload }) => {
      if (payload.event === 'signedIn') setAuthState('authenticated')
      if (payload.event === 'signedOut') setAuthState('unauthenticated')
    })

    return () => unsubscribe()
  }, [])

  async function handleSignOut() {
    await signOut()
    navigate('/')
  }

  return (
  <div>
    <Navbar expand="md" bg="white" className="border-bottom shadow-sm">
      <Container>
        <LinkContainer to="/">
          <Navbar.Brand>
            <img src={logo} className="App-logo" alt="Maple" height="40" />
          </Navbar.Brand>
        </LinkContainer>
        <Navbar.Toggle aria-controls="main-nav" />
        <Navbar.Collapse id="main-nav">
          <Nav className="ms-auto">
            <Nav.Link as={NavLink} to="/" end>Home</Nav.Link>
            <Nav.Link as={NavLink} to="/charities">Charities</Nav.Link>
            {authState === 'authenticated' && (
              <>
                <Nav.Link as={NavLink} to="/admin">Admin</Nav.Link>
                <Button variant="outline-secondary" size="sm" className="ms-2" onClick={handleSignOut}>
                  Sign Out
                </Button>
              </>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>

    <Container as="main" className="py-3">
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<Home />} />
        <Route
          path="/charities"
          element={
            <Row className="justify-content-center">
              <Col xs={12} md={10} lg={8}>
                <CharityList />
              </Col>
            </Row>
          }
        />
        <Route path="/news" element={<News />} />

        {/* Admin routes */}
        <Route path="/admin" element={<AdminLogin />} />
        <Route
          path="/admin/charities"
          element={
            <PrivateRoute>
              <Row className="justify-content-center">
                <Col xs={12} md={10} lg={8}>
                  <AdminCharities />
                </Col>
              </Row>
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/sre"
          element={
            <PrivateRoute>
              <Row className="justify-content-center">
                <Col xs={12} md={10} lg={8}>
                  <AdminSre />
                </Col>
              </Row>
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/stock"
          element={
            <PrivateRoute>
              <Row className="justify-content-center">
                <Col xs={12} md={10} lg={8}>
                  <AdminStock />
                </Col>
              </Row>
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/snp500"
          element={
            <PrivateRoute>
              <Row className="justify-content-center">
                <Col xs={12} md={10} lg={8}>
                  <AdminSnp500 />
                </Col>
              </Row>
            </PrivateRoute>
          }
        />

        <Route
          path="/admin/investments"
          element={
            <PrivateRoute>
              <Row className="justify-content-center">
                <Col xs={12} md={10} lg={8}>
                  <AdminInvestments />
                </Col>
              </Row>
            </PrivateRoute>
          }
        />

        {/* Legacy routes — kept for existing URLs */}
        <Route path="/play-fling" element={<FullArticle tag="play-fling" />} />
        <Route path="/fling-amazon" element={<FullArticle tag="fling-amazon" />} />
        <Route
          path="/fling-coming-amazon-appstore"
          element={<FullArticle tag="fling-coming-amazon-appstore" />}
        />
        <Route path="/fling-google-play" element={<FullArticle tag="fling-google-play" />} />
        <Route
          path="/upcoming-release-fling-it"
          element={<FullArticle tag="upcoming-release-fling-it" />}
        />

        {/* 404 catch-all */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Container>
  </div>
  )
}

export default App
